import { PageHeadAddon, PageHeadProps } from '../types';

/**
 * Type guard: проверяет, что `addonLeft` пришёл как tuple из двух функций.
 * @kind helper
 * @param addonLeft - `addonLeft` PageHead в ненулевом виде
 * @returns `true`, если `addonLeft` — tuple `[PageHeadAddon, PageHeadAddon]`
 */
export const isAddonLeftTuple = (
    addonLeft: NonNullable<PageHeadProps['addonLeft']>,
): addonLeft is readonly [PageHeadAddon, PageHeadAddon] => Array.isArray(addonLeft);
